import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"
import {vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            mapOffsetInPixels: vector2Like,
            maskImage: anyImageOpResult,
            maskOffsetInPixels: vector2Like,
            maskFeathering: z.number(),
            drawMaskOnly: z.boolean(),
            layerMinOpacity: z.number(),
            layerMaxOpacity: z.number(),
            useLaplacianPyramid: z.boolean(),
        }),
    },
}
